import React, { useEffect, useState } from "react";
import { Form, Input, Button, Radio, Typography, Spin, Row, Col, message, } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { routes } from "../../../routes/Routes";
import LeftLayout from "../../pageHeader/LeftLayout";
import _consumerService from "../../../modules/consumerService";
import CurrencyInput from "../../../components/CurrencyInput";
import ConsumerApplicationProgressBar from "../Consumer/ConsumerApplicationProgressBar";
import ConsumerShowApplicationId from "../Consumer/ConsumerShowApplicationId";
import moment from "moment";


const { Title } = Typography;

const QuestionnaireForConsumer = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [responses, setResponses] = useState({});
  const [questionsData, setQuestionsData] = useState([]);
  const [applStatusId, setApplStatusId] = useState(null);
  const ApplicationId = localStorage.getItem("ApplicationId");
  const applicationId = localStorage.getItem("ApplicationObjId");

  const location = useLocation();
  let locData = location.state;
  let applnObjId = "";
  let activeKeyTab = null;
  let fromDashboard = false;
  let selectedApplicationFlow = null;
  if (locData && locData.applicationObjId) {
    applnObjId = locData.applicationObjId;
  }

  if (locData && locData.isFromDashboard) {
    fromDashboard = locData.isFromDashboard;
  }

  if (locData && locData.activeKey) {
    activeKeyTab = locData.activeKey;
  }
  if (locData && locData.selectedDocumentOption) {
        selectedApplicationFlow = locData.selectedDocumentOption;
    }
    
  const [appObjId] = useState(applnObjId);
  const [isFromDashboard] = useState(fromDashboard);
  const [tabActiveKey] = useState(activeKeyTab);
const [selectedApplicationDocFlow] = useState(selectedApplicationFlow);
  useEffect(() => {
    if (!locData || (typeof locData === "object" && Object.keys(locData).length === 0)) {
      history.push({ pathname: routes.consumerDashboard.path });
      return;
    }

    fetchQuestions();
    GetQuestionsByApplicationID();
  }, []);

  useEffect(() => form.resetFields(), [questionsData]);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getAllQuestions();
      if (res.data?.IsSuccess && Array.isArray(res.data.Obj)) {
        setQuestions(res.data.Obj);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const GetQuestionsByApplicationID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getQuestionsByApplicationID(applicationId);
      const data = res.data;

      if (Array.isArray(data) && data.length > 0) {
        setApplStatusId(data && data[0] && data[0].Application_Status_Id);
        const initialResponses = {};
        const formValues = { question: {} };

        data.forEach((item) => {
          const questionId = item.QuestionId;
          const answer = item.Answer ? "yes" : "no";
          const amount = item.Amount || "";
          const details = item.Description || "";

          // Responses state
          initialResponses[questionId] = {
            answer,
            amount,
            details,
          };

          // Form values for pre-fill
          formValues.question[questionId] = {
            answer,
            amount,
            details,
          };
        });

        setResponses(initialResponses);
        form.setFieldsValue(formValues); // This pre-fills the form
      } else {
        // First time visit — nothing to set
        setResponses({});
        form.resetFields();
      }
    } catch (err) {
      console.error("Error fetching question data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleOptionChange = (id, value) => {
    setResponses((prev) => ({
      ...prev,
      [id]: { ...prev[id], answer: value },
    }));

    // Validate the changed field
    form.validateFields([["question", id, "answer"]]);

    // Also clear any previous details/amount if changing from "yes" to "no"
    if (value === "no") {
      setResponses((prev) => ({
        ...prev,
        [id]: { answer: "no", details: "", amount: "" },
      }));
      form.setFieldsValue({
        question: {
          [id]: {
            amount: undefined,
            details: undefined,
          },
        },
      });
    }
  };

  const handleInputChange = (id, field, value) => {
    setResponses((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));

    form.validateFields([["question", id, field]]);
  };


  const onBack = () => {
    // if (isFromDashboard) {
    //   history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
    // } else {
    //   history.push(routes.balanceSheetTotalLiabilities.path);
    // }
    if (selectedApplicationDocFlow) {
      history.push({ pathname: routes.balanceSheetTotalLiabilitiesForConsumer.path, state: { applicationObjId: appObjId, selectedDocumentOption: selectedApplicationDocFlow } });
    } else {
      history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });
    }

  }

  const onFinish = async () => {
    setLoading(true);
    try {
      await form.validateFields(); // Validate all fields first

      const payload = {
        ApplicationId: applicationId,
        IsQuestionairCompleted: true,
        IsAllStepsCompleted: true,
        listquestions: Object.entries(responses).map(([questionId, data]) => ({
          QuestionId: parseInt(questionId),
          ApplicationId: applicationId,
          Answer: data.answer === "yes",
          Description: data.answer === "yes" ? data.details : null,
          Amount: data.answer === "yes" ? data.amount : null,
        })),
      };

      const res = await _consumerService.addOrUpdateQuestions(payload);
      if (res.data.IsSuccess) {
        //   if (isFromDashboard) {
        //     history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        //     localStorage.setItem("fromUserLoginScreen", true);
        //     localStorage.setItem("fromBalanceSheetScreen", false);
        //   } else {
        //     history.push({ pathname: routes.dashboard.path, state: { activeKey: "2" } });
        //     localStorage.setItem("fromUserLoginScreen", false);
        //     localStorage.setItem("fromBalanceSheetScreen", true);
        //   }
        //   localStorage.setItem("ApplicationObjId", applicationId);
        //   localStorage.setItem("isFromMyApplicationsList", false);
        //   message.success(res.data.Message);

        history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });
        localStorage.setItem("IsQuestionairCompleted", true);
        localStorage.setItem("IsAllStepsCompleted", true);
      }
    } catch (error) {
      console.error("Validation failed or submission error:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderQuestion = (q) => {
    const response = responses[q.Id] || {};

    return (
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <div key={q.Id}>
          <Form.Item
            label={
              <span>
                {q.QuestionText}
                <span style={{ color: "red", marginLeft: 2 }}>*</span>
              </span>
            }
            name={["question", q.Id, "answer"]}
            rules={[{ message: "Please Select Yes or No" }]}
            validateTrigger="onSubmit"
            className="questionForm"
          >
            <Radio.Group
              onChange={(e) => handleOptionChange(q.Id, e.target.value)}
              value={response.answer}
            >
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </Radio.Group>
          </Form.Item>

          {response.answer === "yes" && (
            <>
              <Form.Item
                label={
                  <span>
                    Amount
                  </span>
                }
                name={["question", q.Id, "amount"]}
                rules={[{ required: true, message: "Enter Amount is required" }]}
                validateTrigger="onSubmit"

              >
                <CurrencyInput
                  value={response.amount}
                  onChange={(val) => handleInputChange(q.Id, "amount", val)}
                  placeholder="Enter Amount"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    Comments
                  </span>
                }
                name={["question", q.Id, "details"]}
                rules={[{ required: true, message: "Comments are required" }]}
                validateTrigger="onSubmit"

              >
                <Input.TextArea
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  maxLength={500}
                  value={response.details}
                  onChange={(e) => handleInputChange(q.Id, "details", e.target.value)}
                  placeholder="Enter Comments"
                />
              </Form.Item>
            </>
          )}
        </div>
      </Col>
    );
  };

  const assetQuestions = questions.filter((q) => q.QuestionType === "Asset");
  const liabilityQuestions = questions.filter(
    (q) => q.QuestionType === "ConditionalLiability"
  );

  const hasQuestions = Array.isArray(questions) && questions.length > 0;


  return (
    <Spin spinning={loading}>
      <LeftLayout>
        {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
          <div style={{
            position: "absolute",
            top: 5,
            right: 20,
            margin: 0,
            zIndex: 1000,
            maxWidth: "1000px",
            padding: "8px 16px",
            display: "none"
          }}>
            <ConsumerApplicationProgressBar />
            <Title level={3} style={{ margin: 0 }}>
              <ConsumerShowApplicationId />
            </Title>
          </div>
        )}

        <div className="Questionnaire-wrapper">
          <div className="Questionnaire-card">
            <Title level={3}>
              Balance Sheet – Questionnaire
            </Title>

            {hasQuestions ? (
              <>

                <Form form={form} layout="vertical" onFinish={onFinish}>
                  <Title level={5}>
                    Balance Sheet – Questionnaire
                  </Title>
                  <Row gutter={16} >
                    {assetQuestions.map(renderQuestion)}
                  </Row>
                  <Title level={5}>
                    Contingent Liabilities:
                  </Title>
                  <Row gutter={16} >
                    {liabilityQuestions.map(renderQuestion)}
                  </Row>
                  <Row gutter={16} >
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Form.Item style={{ marginTop: 30 }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "16px",
                          }}
                        >
                          <Button
                            onClick={onBack}
                            icon={<LeftOutlined />}
                          >
                            Go Back
                          </Button>
                          <Button
                            type="primary"
                            htmlType="submit"
                            disabled={applStatusId != null && ![1, 6].includes(applStatusId) ? true : false}
                          >
                            Save And Proceed <RightOutlined />
                          </Button>
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </>
            ) : " "}


          </div>
        </div>
      </LeftLayout>
    </Spin>
  );
};

export default QuestionnaireForConsumer;